'use strict';

var _ = require('lodash');
var ChartDashboardPerformanceDataService = function ChartDashboardPerformanceDataService($q, dataRetrieverService, dashboardAggregatingService, retrieverConstants) {
  var dataRetriever = dataRetrieverService.getDataRetriever(retrieverConstants.DASHBOARD_SCREEN, retrieverConstants.MARKET_DASHBOARD_MODE);
  function getLocalMarkets(data) {
    return _.chain(data).filter('isLocal').map('market').uniq().value();
  }
  function aggregatePerMonth(data, metric, aggregationMode) {
    var dataLength = data.length;
    if (dataLength === 0) {
      return {};
    }
    return _.map(_.range(12), function (i) {
      var monthData = dashboardAggregatingService.aggregateForMonths(data, metric, aggregationMode, [i]);
      monthData.isGap = _.isEmpty(monthData);
      monthData.month = i;
      return monthData;
    });
  }
  function aggregateForSummary(data, metric, aggregationMode, selectedMonths) {
    return dashboardAggregatingService.aggregateForMonths(data, metric, aggregationMode, selectedMonths);
  }
  function getData(metric, aggregationMode, selectedMonths) {
    return dataRetriever.localSortApplied().retrieveComponentData('dashboard-performance', metric).then(function (data) {
      return {
        localMarkets: getLocalMarkets(data),
        monthData: aggregatePerMonth(data, metric, aggregationMode),
        summary: aggregateForSummary(data, metric, aggregationMode, selectedMonths)
      };
    });
  }
  return {
    getData: getData
  };
};
ChartDashboardPerformanceDataService.$inject = ['$q', 'DataRetrieverService', 'DashboardAggregatingService', 'DataRetrieverConstantsService'];
module.exports = ChartDashboardPerformanceDataService;